import { CLEAR_IMPERSONATION_ACCESS_TOKEN_COOKIE_ENDPOINT } from '@dtx-company/true-common/src/constants/endpoints'
import { logger } from '@dtx-company/logger'

export async function clearImpersonationAccessTokenCookie(): Promise<void> {
  try {
    const res = await fetch(CLEAR_IMPERSONATION_ACCESS_TOKEN_COOKIE_ENDPOINT, { method: 'POST' })
    if (!res.ok) {
      await logger.logFetchError(res, { technicalArea: 'authentication' })
    }
  } catch (e) {
    logger.logError(e, { technicalArea: 'authentication' })
  }
}
